import Button from '@carvana/ds-button';
import { CircleAlert } from 'lucide-react';
import { icon } from '@carvana/ds-styles';
import React from 'react';
import { EventedModal, ModalNames } from '|/app/modals';
import { useOrderSummaryContext } from '../../../contexts/orderSummary';
import { useTransferScheduleContext } from '../../../contexts/transferSchedule';
import { formatTimeSlotForDisplay } from '../../../utils/dateFormatters';
import { getTransferTypeFriendly } from '../../../utils/transferHelpers';
import { AlertModalContent } from '../AlertModalContent';

interface TimeSlotSelectionAlertModalProps {
  isOpen: boolean;
  onButtonClick: () => void;
}

export const TimeSlotSelectionAlertModal: React.FC<TimeSlotSelectionAlertModalProps> = ({
  isOpen,
  onButtonClick
}) => {
  const {
    state: { selectedTimeSlot }
  } = useTransferScheduleContext();
  const {
    state: {
      orderSummary: { transfer }
    }
  } = useOrderSummaryContext();

  const formattedDeliveryType = getTransferTypeFriendly(transfer);
  const formattedTimeSlot =
    selectedTimeSlot.date && selectedTimeSlot.time
      ? formatTimeSlotForDisplay(selectedTimeSlot.date, selectedTimeSlot.time)
      : '';

  return (
    <EventedModal
      isOpen={isOpen}
      analyticsId={ModalNames.TimeSlotSubmissionError}
      zIndex={10000000}
      closeIcon={false}
      divLine={false}
      desktopWidth={'480px'}
      aria-labelledby="time-slot-selection-alert-modal-title"
    >
      <AlertModalContent
        title="Time slot unavailable"
        titleId="time-slot-selection-alert-modal-title"
        subtext={`Your ${formattedDeliveryType} time on ${formattedTimeSlot} is no longer available. Please select a new ${formattedDeliveryType} time.`}
        icon={<CircleAlert size={24} color={icon.warning} />}
        action={
          <Button
            variant="primary"
            width="100%"
            onClick={onButtonClick}
            data-analytics-id="pp_time_slot_error_select_new_time"
          >
            Select new time
          </Button>
        }
      />
    </EventedModal>
  );
};
